"use strict";
exports.__esModule = true;
exports.SELF_PAY_SERVICE_ISSUE_CONTENT = void 0;
exports.SELF_PAY_SERVICE_ISSUE_CONTENT = {
    SELF_PAY_OFFERED: {
        RENT_TRACKER_MAIN_TEXT: 'We couldn’t pay your rent to your property',
        RENT_TRACKER_SUBTEXT: 'We’ll provide a Flex {{selfPayPaymentMethod}} with your full rent. Use the {{selfPayPaymentMethod}} to submit your rent directly to your property by {{cycleDueDate}} (or before rent is due).',
        RENT_TRACKER_CTA: 'Submit rent',
        BILL_STATUS_SUBTEXT: 'until you submit rent'
    },
    SELF_PAY_ISSUED: {
        RENT_TRACKER_MAIN_TEXT: 'Submit rent to your property',
        RENT_TRACKER_SUBTEXT: 'Enter the Flex {{selfPayPaymentMethod}} info into your property’s portal and submit rent before the {{cycleDueDay}} (or before rent is due). It may take up to 4 business days for your rent to process.',
        RENT_TRACKER_CTA: 'Submit rent'
    }
};
